export const LogoMark = ({ className = "h-8 w-auto" }) => (
  <img src="/images/logo-wave.png" alt="" aria-hidden="true" className={className} draggable="false" />
);

export const Logo = ({ testId = "brand-logo", href = "#top" }) => (
  <a href={href} data-testid={testId} className="group block shrink-0" aria-label="REVIVO-Smartpool – zur Startseite">
    <img
      src="/images/logo-full.png"
      alt="revivo-smartpool"
      className="h-11 sm:h-14 w-auto transition-transform duration-500 group-hover:scale-[1.03]"
      draggable="false"
    />
  </a>
);
